import MUIDataTable from "mui-datatables";
import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import moment from "moment";
const ReportTable = ({ report }) => {
  const columns = [
    {
      name: "from",
      label: "From",
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: "to",
      label: "To",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "itemCount",
      label: "Item Count",
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: "startedAt",
      label: "Started At",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "dueBy",
      label: "Due By",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "totalPaid",
      label: "Total Paid",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "balance",
      label: "Balance",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "paidDate",
      label: "Paid Date",
      options: {
        filter: false,
        sort: true,
      },
    },
  ];

  const options = {
    print: false,
    selectableRowsHideCheckboxes: true,
    responsive: "simple",
    download: true,
  };

  const getMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTableBodyCell: {
          styleOverrides: {
            root: {
              fontFamily: "Inter",
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "400",
            },
          },
        },
      },
    });

  return (
    <div className="report-table-container">
      <ThemeProvider theme={getMuiTheme}>
        <div className="report-info-top-container">
          <p>{report.title}</p>
          <p
            onClick={() => {
              navigator.clipboard.writeText(window.location.href);
              alert("Report Link Copied to Clipboard");
            }}
          >
            Copy Report Link
          </p>
          <p>
            Link is Valid for{" "}
            {moment(report.createdAt).add(24, "hours").diff(moment(), "hours")}{" "}
            hours
          </p>
        </div>
        <MUIDataTable
          data={report.reportInfo}
          title={""}
          columns={columns}
          options={options}
        />
      </ThemeProvider>
    </div>
  );
};

export default ReportTable;
